/* sl-kiosk-addons: in-store kiosk extras (only runs when <html> has .sl-kiosk — see layout/theme.liquid).
   - Product page (mattresses): adjustable-base add-on (Ergomotion 2.0 / 4.0 / 5.0), priced for the chosen
     mattress size and added to the cart together with the mattress.
   - Cart page: "Back" + reset-countdown bar, and a discount-code box (Shopify cart discount codes). */
(function () {
  var html = document.documentElement;
  if (!html.classList.contains('sl-kiosk')) return;

  var BASES = [
    { key: '2.0', handle: 'ergomotion-x-sleep-loft-series-1', name: 'Ergomotion 2.0', feat: 'Head and/or foot' },
    { key: '4.0', handle: 'ergomotion-x-sleep-loft-series-4', name: 'Ergomotion 4.0', feat: 'Head and/or foot + massage' },
    { key: '5.0', handle: 'ergomotion-x-sleep-loft-series-5', name: 'Ergomotion 5.0', feat: 'Lumbar, head and/or foot + massage + anti-snore' }
  ];
  // mattress size -> base variant title (Twin and California King have no matching base)
  var SIZE_MAP = { 'twin xl': 'Twin XL', 'full': 'Full', 'queen': 'Queen', 'king': 'King' };

  function money(cents) {
    var d = cents / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function thumb(b) {
    var src = b.product && (b.product.featured_image || (b.product.images || [])[0]);
    if (!src) return '';
    src = (src.indexOf('//') === 0 ? 'https:' : '') + src;
    return '<img class="slk-opt__img" src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="52" height="34" loading="lazy">';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------------- product page: adjustable base add-on ---------------- */
  function initBaseAddon() {
    var info = document.querySelector('.product__info-container');
    var form = info && info.querySelector('product-form form[action*="/cart/add"]');
    var picker = info && info.querySelector('variant-radios, variant-selects');
    if (!form || !picker) return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;

    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      if (!/mattress/i.test(prod.type || '') || /\bbases?\b|foundation|frame|protector/i.test(prod.title)) return; // ("Pillow Top" mattresses are mattresses)
      return Promise.all(BASES.map(function (b) {
        return fetch('/products/' + b.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
          .then(function (j) { b.product = j; return b; });
      })).then(function (bases) { build(prod, bases.filter(function (b) { return b.product; })); });
    }).catch(function () {});

    function build(prod, bases) {
      if (!bases.length) return;
      var box = document.createElement('div');
      box.className = 'slk-addon';
      box.innerHTML = '<div class="slk-addon__head">Add an adjustable base <span>optional</span></div><div class="slk-addon__list" role="radiogroup" aria-label="Adjustable base"></div>';
      var list = box.querySelector('.slk-addon__list');
      var choice = null; // {base, variant}

      function sizeNow() {
        // the size option (mattresses may also have firmness / height options)
        var all = [].slice.call(picker.querySelectorAll('input[type=radio]:checked, select'));
        var hit = all.find(function (el) { return /twin|full|queen|king/i.test(el.value); }) || all[0];
        var v = hit ? hit.value : '';
        return String(v || '').trim().toLowerCase();
      }
      function render() {
        var size = sizeNow(), want = SIZE_MAP[size], sizeLabel = size.replace(/\b\w/g, function (m) { return m.toUpperCase(); });
        var rows = ['<button type="button" class="slk-opt' + (choice ? '' : ' is-on') + '" data-key="" role="radio" aria-checked="' + (!choice) + '">' +
          '<span class="slk-opt__dot"></span><span class="slk-opt__txt"><b>No adjustable base</b></span><span class="slk-opt__price"></span></button>'];
        if (!want) {
          choice = null;
          list.innerHTML = '<p class="slk-addon__none">Adjustable bases are available for Twin XL, Full, Queen and King.</p>';
          return;
        }
        var stillOk = false;
        bases.forEach(function (b) {
          var v = want && b.product.variants.find(function (x) { return x.title.toLowerCase() === want.toLowerCase(); });
          var ok = !!(v && v.available);
          if (choice && choice.base === b && ok) { choice.variant = v; stillOk = true; }
          var on = choice && choice.base === b && ok;
          rows.push('<button type="button" class="slk-opt' + (on ? ' is-on' : '') + (ok ? '' : ' is-off') + '" data-key="' + b.key + '" role="radio" aria-checked="' + !!on + '"' + (ok ? '' : ' disabled') + '>' +
            '<span class="slk-opt__dot"></span>' + thumb(b) + '<span class="slk-opt__txt"><b>' + esc(b.name) + '</b><small>' + esc(b.feat) + '</small></span>' +
            '<span class="slk-opt__price">' + (ok ? '+' + money(v.price) : 'Not in ' + esc(sizeLabel)) + '</span></button>');
        });
        if (choice && !stillOk) choice = null;
        if (!choice) rows[0] = rows[0].replace('slk-opt"', 'slk-opt is-on"').replace('aria-checked="false"', 'aria-checked="true"');
        list.innerHTML = rows.join('');
      }
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.slk-opt');
        if (!btn || btn.disabled) return;
        var key = btn.getAttribute('data-key');
        choice = key ? { base: bases.find(function (b) { return b.key === key; }) } : null;
        render();
      });
      picker.addEventListener('change', function () { setTimeout(render, 0); });

      // sit between the size buttons and Add to cart
      var anchor = form.closest('.product-form') || form.closest('product-form') || form;
      var slot = anchor;
      while (slot.parentElement && slot.parentElement !== info) slot = slot.parentElement;
      info.insertBefore(box, slot);
      render();

      // Add to cart: mattress + chosen base in one request, then straight to the cart
      document.addEventListener('submit', function (e) {
        if (e.target !== form || !choice || !choice.variant) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var id = Number((form.querySelector('[name="id"]') || {}).value);
        if (!id) return;
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
        var mv = prod.variants.find(function (x) { return x.id === id; });
        // base first so the cart (newest on top) lists the mattress above its base
        postJSON('/cart/add.js', { items: [
          { id: choice.variant.id, quantity: 1, properties: { '_With mattress': prod.title + (mv ? ' (' + mv.title + ')' : '') } },
          { id: id, quantity: 1 }
        ] }).then(function () { location.href = '/cart'; })
          .catch(function (err) {
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
            alertBox((err && (err.description || err.message)) || 'Sorry, that could not be added. Please ask a team member.');
          });
      }, true);

      function alertBox(msg) {
        var m = box.querySelector('.slk-addon__err') || box.appendChild(Object.assign(document.createElement('div'), { className: 'slk-addon__err' }));
        m.textContent = msg;
      }
    }
  }

  /* ---------------- cart page: back + countdown bar, discount codes ---------------- */
  function initCart() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    // Back + countdown (countdown only on locked kiosks, which are the ones that reset)
    var bar = document.createElement('div');
    bar.className = 'slk-cartbar';
    bar.innerHTML = '<button type="button" class="slk-cartbar__back">&lsaquo; Back</button><span class="slk-cartbar__timer" aria-live="polite"></span>';
    main.insertBefore(bar, main.firstChild);
    bar.querySelector('.slk-cartbar__back').addEventListener('click', function () {
      if (window.slKioskHome) location.href = window.slKioskHome; else history.back();
    });
    var timer = bar.querySelector('.slk-cartbar__timer');
    function tick() {
      if (!window.slKioskDue) { timer.textContent = ''; return; }
      var s = Math.max(0, Math.ceil((window.slKioskDue - Date.now()) / 1000));
      timer.textContent = 'Cart resets in ' + Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2) + ' if the screen isn’t touched';
      timer.classList.toggle('slk-soon', s <= 30);
    }
    tick(); setInterval(tick, 1000);

    // Discount code box, just above Check out
    var ctas = document.querySelector('.cart__ctas');
    if (!ctas) return;
    var d = document.createElement('div');
    d.className = 'slk-disc';
    d.innerHTML = '<form class="slk-disc__form" novalidate><input class="slk-disc__input" name="code" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Discount code" aria-label="Discount code">' +
      '<button class="slk-disc__btn" type="submit">Apply</button></form><div class="slk-disc__applied"></div><div class="slk-disc__msg" role="status"></div>';
    ctas.parentNode.insertBefore(d, ctas);
    var input = d.querySelector('input'), msg = d.querySelector('.slk-disc__msg'), applied = d.querySelector('.slk-disc__applied'), btn = d.querySelector('.slk-disc__btn');
    function say(t, bad) { msg.textContent = t || ''; msg.classList.toggle('is-bad', !!bad); }
    function show(cart) {
      var ok = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
      applied.innerHTML = ok.map(function (c) {
        return '<span class="slk-disc__chip">✓ ' + esc(c.code) + ' <button type="button" data-code="' + esc(c.code) + '" aria-label="Remove ' + esc(c.code) + '">&times;</button></span>';
      }).join('') + (ok.length && cart.total_discount ? '<span class="slk-disc__save">You save ' + money(cart.total_discount) + '</span>' : '');
      return ok.map(function (c) { return c.code; });
    }
    var current = [];
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { current = show(c); });
    try { var flash = sessionStorage.getItem('slk-disc-msg'); if (flash) { sessionStorage.removeItem('slk-disc-msg'); say(flash); } } catch (e) {}

    function setCodes(codes) { return postJSON('/cart/update.js', { discount: codes.join(',') }); }
    d.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var code = input.value.trim();
      if (!code) { say('Enter a discount code.', true); return; }
      if (current.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { say(code + ' is already applied.'); return; }
      btn.disabled = true; say('Checking…');
      setCodes(current.concat(code)).then(function (cart) {
        var hit = (cart.discount_codes || []).find(function (c) { return c.code.toLowerCase() === code.toLowerCase(); });
        if (hit && hit.applicable) {
          try { sessionStorage.setItem('slk-disc-msg', 'Discount ' + hit.code + ' applied.'); } catch (e2) {}
          location.reload(); // re-render totals with the discount
        } else {
          return setCodes(current).then(function () { btn.disabled = false; say('Sorry, "' + code + '" can’t be used on this order.', true); });
        }
      }).catch(function () { btn.disabled = false; say('Something went wrong. Please try again.', true); });
    });
    applied.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-code]'); if (!b) return;
      var code = b.getAttribute('data-code');
      setCodes(current.filter(function (c) { return c !== code; })).then(function () {
        try { sessionStorage.setItem('slk-disc-msg', 'Discount ' + code + ' removed.'); } catch (e2) {}
        location.reload();
      });
    });
  }

  function start() {
    if (/^\/products\//.test(location.pathname) || /\/products\//.test(location.pathname)) initBaseAddon();
    if (/^\/cart\/?$/.test(location.pathname)) initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
